export default __webpack_public_path__ + "static/media/1.0660a5a2.png";